export default __webpack_public_path__ + "static/media/Search.5c0f0c1a.svg";